/* eslint-disable no-unused-vars */
export enum StrategyType {
  Structure = "Structure",
  Outright = "Outright",
}
